var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPickupDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_plane-copy-icons/24x24/ico_marker",
    fill: "#B2B2B2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33333333,12.6666667 L2,12.6666667 L2,1.33333333 L14,1.33333333 L14,12.6666667 L9.66666667,12.6666667 L8,14.3333333 L6.33333333,12.6666667 Z M12.6666667,11.3333333 L12.6666667,2.66666667 L3.33333333,2.66666667 L3.33333333,11.3333333 L6.66666667,11.3333333 L8,12.6666667 L9.33333333,11.3333333 L12.6666667,11.3333333 Z M6.66666667,8.33333333 L6.66666667,5.66666667 L9.33333333,5.66666667 L9.33333333,8.33333333 L6.66666667,8.33333333 Z",
    id: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPickupDrop);
export default __webpack_public_path__ + "static/media/ico_pickup_drop.7454703329aa481e19de34ec13b18f75.svg";
export { ForwardRef as ReactComponent };